import LatestNews from '@/services/LatestNews';
import UnixDate from '@/utils/DateTime';

import * as Sentry from '@sentry/browser';

const CACHED_TIMEOUT = 300; // 5 Minutes

export default {
	state: {
		news: [],
		lastPull: null,
	},
	getters: {
		news: state => state.news,
		lastPull: state => state.lastPull,
	},
	mutations: {
		setLatestNews: (state, news) => {
			state.news = news;
		},
		setLastPull: (state, lastPull) => {
			state.lastPull = lastPull;
		},
	},
	actions: {
		getLatestNews: async (context, payload) => {
			const currentTimestamp = UnixDate.now();
			if (CACHED_TIMEOUT <= currentTimestamp - context.getters.lastPull) {
				try {
					const getNews = await LatestNews.getNews();

					if (getNews.data.length > 0) {
						context.commit('setLatestNews', getNews.data);
					}
				} catch (e) {
					Sentry.captureException(e);
					context.commit('setLatestNews', []);
				} finally {
					context.commit('setLastPull', currentTimestamp);
				}
			}

			return context.getters.news;
		},
	},
};
